// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"468":"01ef97d3","942":"e169d44e"}[chunkId] + ".chunk.js";
};